//options: https://glidejs.com/docs/options/
import Glide from '@glidejs/glide'
import A11yDialog from 'a11y-dialog';
import breakpoints from '../breakpoints';

/**
 * Create a carousel for vehicle page image carousel
 */
export const init = () => {
  const carouselElement = document.querySelector('.vehicle-image-carousel .glide');

  const glide = new Glide(carouselElement, {
    type: 'carousel',
    focusAt: 'center',
    startAt: 0,
    perView: 1,
    peek: 700,
    gap: 8,
    keyboard: false, //keyboard arrows controlled carousel even if it was not selected
    breakpoints: {
      [breakpoints.xxxl]: {
        peek: 550
      },
      [breakpoints.xxl]: {
        peek: 400
      },
      [breakpoints.xl]: {
        peek: 300
      },
      [breakpoints.lg]: {
        peek: 100
      },
      [breakpoints.sm]: {
        peek: 35
      },
      [breakpoints.xs]: {
        perView: 1,
        gap: 1,
        peek: 0
      }
    }

  });

  /**
   * update current slide number
   */
  glide.on('move.after', function() {
    const text = document.querySelector('.js-vehicle-image-carousel__running-number');
    if(text && typeof glide.index === 'number') text.innerHTML = glide.index + 1 + '&nbsp;';
  });

  //add data attribute to slides so we can activate that slide by clicking on it
  carouselElement.querySelectorAll('.glide__slide').forEach((slide, index) => {
    slide.dataset.sliderIndex = index
  });

  glide.mount();

  //activate that slide by clicking on it
  carouselElement.querySelectorAll('.glide__slide').forEach((slide) => {
    slide.addEventListener('click', () => {
      const sliderIndex = slide.dataset.sliderIndex;
      if (sliderIndex && sliderIndex >= 0) glide.go('='+sliderIndex);
    });
  });


  /**
   * Create vehicle image modal
   */
  const imageModalElement = document.getElementById('vehicle-image-modal');
  if(imageModalElement) {
    const dialog = new A11yDialog(imageModalElement);

    const modalOpenButton = document.querySelector('button[data-a11y-dialog-show]');
    modalOpenButton.addEventListener('click', () => {
      // Push state when opening modal
      history.pushState({modalOpen: true}, '', window.location.pathname);
    });

    const modalCloseButtons = document.querySelectorAll('*[data-a11y-dialog-hide]');
    modalCloseButtons.forEach((closeButton) => {
      closeButton.addEventListener('click', () => {
        dialog.hide();
        // Only update history if we didn't get here via back button
        if (history.state && history.state.modalOpen === true) {
          history.replaceState({modalOpen: false}, '', window.location.pathname);
        }
      });
    });

    //handle browser back button when modal is open
    window.onpopstate = (e) => {
      // If back button is pressed while modal is open, just close it
      if (dialog.shown === true) {
        dialog.hide();
        return;
      }

      // Handle other history state changes if needed
      if(e.state?.modalOpen === true && dialog.shown === false) {
        dialog.show();
      }
    };
  }
}
